import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  clients: [],
  maps: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalClients: 0,
    totalPages: 0
  },
  clientsCatalog: {},
  categoriesCatalog: [],
  filterParams: '',
  isModalVisible: false,
  isModalImagesVisible: false
}

const mutations = {
  SET_CLIENTS (state, payload) {
    state.clients = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalClients: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_CATEGORIES_CATALOG (state, payload) {
    state.categoriesCatalog = payload
  },
  SET_MAPS (state, payload) {
    state.maps = payload
  },
  ADD_CLIENT (state, payload) {
    state.clients.unshift(payload)
  },
  UPDATE_CLIENT (state, payload) {
    const idx = state.clients.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.clients, idx, payload)
    }
  },
  DELETE_CLIENT (state, payload) {
    const idx = state.clients.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.clients, idx)
    }
  },
  DELETE_CLIENTS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.clients.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.clients, idx)
      }
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_IMAGES_VISIBLE (state, payload) {
    state.isModalImagesVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.clientsCatalog[object] = payload.data
  },
  SET_CLIENTS_CATALOG (state, payload) {
    state.clientsCatalog = { ...state.clientsCatalog, ...payload }
  }
}

const actions = {
  async loadClients ({ commit }, payload) {
    if (!payload.map_id) { payload.map_id = 1 }
    app.$Progress.start()
    try {
      const response = await axios.get(`clients?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CLIENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadMaps ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`maps/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MAPS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCategoriesCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`categories/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATEGORIES_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addClient ({ commit }, payload) {
    const client = {
      // columnas
      // sku: payload.sku,
    }

    app.$Progress.start()

    try {
      const response = await axios.post('clients', client)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_CLIENT', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.clients', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editClient ({ commit }, payload) {
    const client = {
      id: payload.id,
      layer_id: payload.layer_id,
      title: payload.title,
      about: payload.about,
      description: payload.description,
      category: payload.category,
      link: payload.link,
      fill: payload.fill,
      x: payload.x,
      y: payload.y,
      zoom: parseInt(payload.zoom),
      status: parseInt(payload.status),
      map_id: parseInt(payload.map_id)
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`clients/${payload.id}`, client)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CLIENT', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.clients', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteClientImage ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`client-image/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.clients', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteClient ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`clients/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CLIENT', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.clients', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteClients ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`clients/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CLIENTS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.clients', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionClient ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`clients/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CLIENT', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.clients', text: `clients.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/clients/export?format=csv' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadClientsCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`clients/catalog`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.clients', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CLIENTS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalImagesVisible ({ commit }, payload) {
    commit('SET_MODAL_IMAGES_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  clients: state => state.clients,
  maps: state => state.maps,
  clientsCatalog: state => state.clientsCatalog,
  categoriesCatalog: state => state.categoriesCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalImagesVisible: state => state.isModalImagesVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
